import React, { memo } from "react";
import { motion } from "framer-motion";

function RemoveCart(props) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.92 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.92 }}
      transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
      style={{
        position: "fixed", inset: 0, zIndex: 50,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 24,
      }}
    >
      <div style={{
        background: "#fff", borderRadius: 20,
        boxShadow: "0 24px 80px rgba(0,0,0,0.22)",
        padding: "36px 32px", maxWidth: 380, width: "100%",
        textAlign: "center",
      }}>
        {/* Icon */}
        <div style={{
          width: 64, height: 64, borderRadius: "50%",
          background: "rgba(220,38,38,0.09)",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 20px",
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2">
            <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
          </svg>
        </div>

        <h3 style={{ fontFamily: "Cormorant Garamond, Georgia, serif", fontSize: 22, fontWeight: 700, color: "#1c1c1e", margin: "0 0 8px" }}>
          Remove Item?
        </h3>
        <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 28px", lineHeight: 1.6 }}>
          This item will be removed from your shopping bag.
        </p>

        <div style={{ display: "flex", gap: 12 }}>
          <button
            onClick={() => props.setShowModal("")}
            style={{
              flex: 1, padding: "12px 0",
              background: "#f5f5f7", color: "#1c1c1e",
              fontSize: 13.5, fontWeight: 600,
              border: "none", borderRadius: 12, cursor: "pointer",
              transition: "background .16s",
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#e5e5ea"}
            onMouseLeave={(e) => e.currentTarget.style.background = "#f5f5f7"}
          >
            Keep It
          </button>
          <button
            onClick={() => props.removeItemFromCart(props.showModal)}
            style={{
              flex: 1, padding: "12px 0",
              background: "#dc2626", color: "#fff",
              fontSize: 13.5, fontWeight: 600,
              border: "none", borderRadius: 12, cursor: "pointer",
              transition: "background .16s",
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#b91c1c"}
            onMouseLeave={(e) => e.currentTarget.style.background = "#dc2626"}
          >
            Remove
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default memo(RemoveCart);
